<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useFormModel } from "@/hooks";
import type { InputAlign } from "@nutui/nutui";
import type { PickerOption } from "@nutui/nutui/dist/types/__VUE/picker/types";
import { ref, computed } from "vue";
const props = defineProps<{
  modelValue?: string;
  separator?: string;
  items: PickerOption[];
  columnNum: number;
  formats: string[];
  placeholder?: string;
  inputAlign?: InputAlign;
}>();

const emit = defineEmits(["update:modelValue", "change"]);

const show = ref(false);
const columns = computed(() =>
  new Array(props.columnNum).fill(null).map((_) => props.items)
);

const displayValue = computed(() => {
  if (!props.modelValue) return "";
  return props.modelValue
    .split(",")
    .map((item, index) => {
      const text = props.items.find((opt) => opt.value === item)
        ?.text as string;
      return props.formats[index]
        ? props.formats[index].replace(/@value@/g, text)
        : text;
    })
    .join(props.separator || "");
});

function click() {
  show.value = true;
}

function confirm({ selectedValue }: any) {
  show.value = false;
  const value = selectedValue.length > 0 ? selectedValue.join(",") : "";
  emit("update:modelValue", value);
  emit("change", value);
}

const { setFormModel } = useFormModel();
defineExpose({ setFormModel });
</script>
<template>
  <div class="mp-picker">
    <nut-input
      :model-value="displayValue"
      :placeholder="placeholder"
      :input-align="inputAlign"
      :border="false"
      readonly
      type="text"
      @click-input="click"
    />
    <nut-popup v-model:visible="show" position="bottom">
      <nut-picker
        v-bind="$attrs"
        :columns="columns"
        @confirm="confirm"
        @cancel="show = false"
      >
        <template #default v-if="$slots.default">
          <slot name="default"
        /></template>
        <template #top v-if="$slots.top"> <slot name="top" /> </template>
      </nut-picker>
    </nut-popup>
  </div>
</template>
<style lang="scss">
.mp-picker {
  width: 100%;
}
</style>
